module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-04.0b85ef7d.png";